module.exports = __webpack_public_path__ + "img/logo.fa5396cf.png";